module.exports = __webpack_public_path__ + "img/manual.899339c0.png";